import schema from "../../gen/schema/witbooking.backoffice.bundle.v2/Bundle.json";

export const getSchema = () => ({
  ...schema,
  properties: {
    ...schema.properties,
    multimedia: {
      ...schema.properties.multimedia,
      items: {
        ...schema.properties.multimedia.items,
        properties: {
          ...schema.properties.multimedia.items.properties,
          translations: {
            ...schema.properties.multimedia.items.properties.translations,
            items: {
              ...schema.properties.multimedia.items.properties.translations.items,
              required: ["title"],
            },
            type: "object",
          },
        },
        additionalProperties: true,
      },
    },
    travelWindowSection: {
      type: "string",
    },
  },
});
